(function() {
    window.TLCustomEventCartGoal = 1;

    let refreshTimer = null;
    const isCartPage = window.location.pathname === "/cart";

    const refreshCartPage = async (doc) => {
        const oldCart = document.querySelector("cart-items");
        const newCart = doc.querySelector("cart-items");

        const newEmpty = doc.querySelector("cart-empty")
                      || doc.querySelector(".cart--empty")
                      || doc.querySelector("[data-cart-empty]");
        if (!newCart || newEmpty) {
            const oldMain = document.getElementById("MainContent") || document.querySelector("main");
            const newMain = doc.getElementById("MainContent") || doc.querySelector("main");
            if (oldMain && newMain) oldMain.innerHTML = newMain.innerHTML;
            return;
        }

        if (oldCart && newCart) oldCart.innerHTML = newCart.innerHTML;

        const oldFooter = document.getElementById("main-cart-footer");
        const newFooter = doc.getElementById("main-cart-footer");
        if (oldFooter && newFooter) oldFooter.innerHTML = newFooter.innerHTML;
    };

    const refreshCartDrawer = async () => {
        const drawer = document.querySelector("#CartDrawer.cart-drawer");
        if (!drawer) return;

        try {
            const res = await fetch(window.location.href, { headers: { 'Cache-Control': 'no-cache' } });
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");

            const newDrawer = doc.querySelector("#CartDrawer.cart-drawer");
            if (!newDrawer) return;

            const oldBody = drawer.querySelector(".drawer__body") || drawer.querySelector(".drawer__inner");
            const newBody = newDrawer.querySelector(".drawer__body") || newDrawer.querySelector(".drawer__inner");
            if (oldBody && newBody) {
                oldBody.innerHTML = newBody.innerHTML;
            } else {
                const oldHeader = drawer.querySelector(".drawer__header");
                const newChildren = Array.from(newDrawer.children);
                Array.from(drawer.children).forEach(child => {
                    if (child !== oldHeader) child.remove();
                });
                newChildren.forEach(child => {
                    if (!child.classList.contains("drawer__header")) {
                        drawer.appendChild(child);
                    }
                });
            }

            // if (window.tlCartGoalEmbed) {
            //     window.tlCartGoalEmbed.renderAllCartGoals();
            // }
        } catch (error) {
            console.error("Salepify Drawer Refresh Error:", error);
        }
    };

    const refreshSitarCart = async () => {
        try {
            if (isCartPage) {
                const res = await fetch(window.location.href, { headers: { 'Cache-Control': 'no-cache' } });
                const html = await res.text();
                const doc = new DOMParser().parseFromString(html, "text/html");
                await refreshCartPage(doc);
            } else {
                await refreshCartDrawer();
            }

            // const countRes = await fetch(window.Shopify.routes.root + 'cart.js');
            // const cart = await countRes.json();
            // const bubbles = document.querySelectorAll(".cart-count-bubble");
            // bubbles.forEach(b => {
            //     b.textContent = cart.item_count;
            //     b.style.display = cart.item_count > 0 ? '' : 'none';
            // });

            if (window.tlCartGoalEmbed) {
                window.tlCartGoalEmbed.renderAllCartGoals();
            }
        } catch (error) {
            console.error("Salepify Refresh Error:", error);
        }
    };

    const scheduleRefresh = (delayMs) => {
        if (refreshTimer) clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refreshSitarCart, delayMs);
    };

    // App internal events
    window.addEventListener("TLCustomEvent:CartGoal-getPassedMilestone", () => scheduleRefresh(500));
    window.addEventListener("TLCustomEvent:CartGoal-handleAutoAddGift", () => scheduleRefresh(100));
    window.addEventListener("TLCustomEvent:CartGoal-handleAddtoCart", () => scheduleRefresh(500));

    // Cart mutation events
    // ['TLCARTGOAL:add', 'TLCARTGOAL:change', 'TLCARTGOAL:update', 'TLCARTGOAL:clear'].forEach(ev => {
    //     window.addEventListener(ev, () => scheduleRefresh(2500));
    // });

    // Page load
    // window.addEventListener('load', () => scheduleRefresh(2000));

})();
